import MenuItem from "@material-ui/core/MenuItem";
import OrgTextField from "@material-ui/core/TextField";
import React from "react";
import { FieldRenderProps } from "react-final-form";
import makeStyles from "@material-ui/core/styles/makeStyles";

export interface SelectProps extends FieldRenderProps<any> {
  options: Array<{ label: string | (() => string); value: any }>;
  clearable: boolean;
  readOnly?: boolean;
}

const useStyles = makeStyles(theme => ({
  select: {
    width: "100%"
  },
  emptyOption: {
    height: "35px"
  }
}));

export const Select = ({
  input: { name, onChange, value, ...restInput },
  meta,
  options,
  clearable,
  readOnly
}: SelectProps) => {
  const classes = useStyles();

  const getOptionLabel = (label: string | (() => string)) => {
    return typeof label === "function" ? label() : label;
  };

  return (
    <OrgTextField
      className={classes.select}
      select={true}
      name={name}
      disabled={readOnly}
      placeholder={name}
      helperText={meta.touched ? meta.error : undefined}
      error={meta.error && meta.touched}
      SelectProps={restInput}
      onChange={onChange}
      value={value}
      variant="outlined"
      margin="dense"
    >
      {!clearable ? null : (
        <MenuItem key={0} value={undefined} className={classes.emptyOption} />
      )}
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {getOptionLabel(option.label)}
        </MenuItem>
      ))}
    </OrgTextField>
  );
};
